document.querySelectorAll('.form-body__item--textarea').forEach(function (itemArea) {
    const message = itemArea.querySelector('.input-textarea')
    const counter = itemArea.querySelector('.counter')

    message.addEventListener('input', function (e) {
        const maxLength = message.getAttribute('maxlength')
        const currentLength = message.value.length

        counter.innerHTML = `${currentLength}/${maxLength}`
    })


})